import { api } from "~/api/index";
import { HanyoListViewModel } from "../models/HanyoListViewModel";
export class HanyoHelper {
    static async getHanyoList(hanyokbList) {
        let hanyoListResult = await api.common.getHanyoList(hanyokbList);
        return new HanyoListViewModel(hanyoListResult);
    }
}
